import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { FavoritesProvider } from "./context/FavoritesContext";
import { AudioProvider } from "./context/AudioContext";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import SpaListings from "./pages/SpaListings";
import SpaDetails from "./pages/SpaDetails";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Gallery from "./pages/Gallery";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

function App() {
  return (
    <div className="App">
      <AudioProvider>
        <FavoritesProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/spas" element={<SpaListings />} />
                <Route path="/spa/:id" element={<SpaDetails />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
              </Routes>
            </main>
            <Footer />
          </BrowserRouter>
          <Toaster 
            position="bottom-right"
            toastOptions={{
              style: {
                background: '#F9F6F0',
                border: '1px solid #E0DAD0',
                color: '#4A4E4D',
              },
            }}
          />
        </FavoritesProvider>
      </AudioProvider>
    </div>
  );
}

export default App;
